/* ============================================================
   Lab Effects — SHARED ADD TO CART
   assets/le-cart-add.js

   THE one add-to-cart path for the whole storefront. Extracted
   verbatim from assets/lab-pdp.js so every PDP — legacy single
   source and merged tri-source — adds items identically.

   Mirrors Horizon's product-form.js: POST /cart/add.js asking for
   the cart-items section HTML, then dispatch the theme's
   'cart:update' event (== CartAddEvent.eventName) with
   source 'product-form-component' + the returned section HTML so
   the cart bubble AND drawer contents refresh exactly like a
   native add. We then explicitly open the drawer so it works
   regardless of the "auto open cart drawer" theme setting.

   Load this BEFORE any script that calls window.LE_addToCart.
   ============================================================ */
(function () {
  /* Emitted globally from layout/theme.liquid AND by the two PDP sections, so
     on a product page this file runs twice. Defining the same functions again
     is harmless, but bailing makes that explicit and keeps the second copy from
     ever quietly diverging. */
  if (window.LE_addToCart) return;

  // Section ids the cart-items components need re-rendered (the header group).
  function getCartSectionIds() {
    var ids = [];
    document.querySelectorAll('cart-items-component').forEach(function (el) {
      var id = el.dataset && el.dataset.sectionId;
      if (id && ids.indexOf(id) === -1) ids.push(id);
    });
    return ids;
  }

  // Open the native Horizon cart drawer (no-op on cart-page templates).
  function openCartDrawer() {
    var drawer = document.querySelector('cart-drawer-component');
    if (!drawer) return;
    var go = function () { if (typeof drawer.open === 'function') drawer.open(); };
    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('cart-drawer-component').then(go);
    } else {
      go();
    }
  }

  // Shared add-to-cart used by the hero form, sticky bar, add-ons and the
  // related-product sheet. Returns a promise that resolves with the cart.
  // The mobile app shell deliberately does NOT slide the drawer out on add —
  // being yanked out of browsing is the behaviour we are trying to remove. It
  // shows a toast + a badge tick instead (see le-mobile.js). Desktop is
  // unchanged: the native Horizon drawer still opens.
  function isMobileShell() {
    return window.matchMedia && window.matchMedia('(max-width: 767px)').matches;
  }

  // opts.openDrawer — true/false to force it either way. Omitted (the normal
  // case) means "drawer on desktop, toast on mobile".
  function addToCart(variantId, qty, opts) {
    opts = opts || {};
    var wantDrawer = opts.openDrawer;
    if (wantDrawer === undefined) wantDrawer = !isMobileShell();
    qty = parseInt(qty, 10) || 1;
    var body = { id: variantId, quantity: qty, sections_url: window.location.pathname };
    var sectionIds = getCartSectionIds();
    if (sectionIds.length) body.sections = sectionIds.join(',');

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) {
        return r.json().then(function (data) { return { ok: r.ok, data: data }; });
      })
      .then(function (res) {
        // Shopify returns { status, message, description } on failure.
        if (!res.ok || res.data.status) {
          throw new Error(res.data.description || res.data.message || 'Add to cart failed');
        }
        var addResponse = res.data;
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            document.dispatchEvent(new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                resource: cart,
                sourceId: 'le-pdp-form',
                data: {
                  source: 'product-form-component',
                  itemCount: qty,
                  sections: addResponse.sections
                }
              }
            }));
            // Fired for every add, on every breakpoint, so anything that
            // wants to react to an add (the mobile toast today) has one
            // signal to listen to and does not have to re-parse cart:update.
            document.dispatchEvent(new CustomEvent('le:cart-added', {
              bubbles: true,
              detail: {
                title: addResponse.product_title || addResponse.title || '',
                quantity: qty,
                variantId: variantId,
                cart: cart
              }
            }));
            if (wantDrawer) openCartDrawer();
            return cart;
          });
      });
  }

  // Exposed for the merged PDP, the related-product variant sheet and add-ons.
  window.LE_addToCart = addToCart;
  window.LE_openCartDrawer = openCartDrawer;
})();
